export const EXPAND_ALL =
    "expand=vehicles.account.integration_settings,vehicles.account.accessories_enabled,tradein,rebates,signatures,person,dealer_changes,experiments,appointments,instant_offers,tracking";
